export default "__VITE_ASSET__BEcBxWga__"